import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaRegUser } from "react-icons/fa";
import { HiOutlineMail, HiArrowNarrowRight } from "react-icons/hi";
import { FiPhoneCall } from "react-icons/fi";
import { SlEnvelopeOpen } from "react-icons/sl";
import "../Footer/Footer.css";
import { Logo } from "../../images";
import apiClient from "../../Config/apiConfig";
import { TailSpin } from "react-loader-spinner";
import { toast } from "react-toastify";
import VisibleError from "../VisibleError";

const Footer = () => {
  const [getInTouch, setGetInTouch] = useState({
    name: "",
    email: "",
    phoneNumber: "",
  });
  const [error, setError] = useState({
    nameError: false,
    emailError: false,
    phoneNumberError: false,
  });
  const [loader, setLoader] = useState(false);
  const { nameError, emailError, phoneNumberError } = error;

  const { name, email, phoneNumber } = getInTouch;
  const handleChange = (e) => {
    setGetInTouch((data) => {
      return {
        ...data,
        [e.target.name]: e.target.value,
      };
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let check = false;
    if (name.trim() === "") {
      setError((old) => {
        return {
          ...old,
          nameError: true,
        };
      });
      check = true;
    }
    if (email.trim() === "") {
      setError((old) => {
        return {
          ...old,
          emailError: true,
        };
      });
      check = true;
    }
    if (phoneNumber.trim() === "") {
      setError((old) => {
        return {
          ...old,
          phoneNumberError: true,
        };
      });
      check = true;
    }
    if (check) {
      return;
    }
    try {
      setLoader(true);
      const allData = { name, email, phoneNumber };
      const res = await apiClient.post(`api/createNewsletter`, {
        allData,
      });
      if (res.data.status === "200") {
        toast.success(res.data.success);
        setGetInTouch({
          name: "",
          email: "",
          phoneNumber: "",
        });
      } else if (res.data.status === "405") {
        toast.warning(res.data.error);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoader(false);
    }
  };


  var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
  (function () {
    var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
    s1.async = true;
    s1.src = 'https://embed.tawk.to/64e5a24bcc26a871b030d37a/1h8gg3ud0';
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');
    s0.parentNode.insertBefore(s1, s0);
  })();
  return (
    <>
      <section className="subscribe-section centred">
        <Container>
          <Row>
            <Col sm="12" className="text-center subscribe-icon">
              <SlEnvelopeOpen />
              <h2>Subscribe Our Newsletter</h2>
              <p>
                Subscribe our newsletter and get latest news, updates to your
                inbox directly.
              </p>
            </Col>
          </Row>
          <Row>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="form-group">
                <FaRegUser />
                <input
                  type="text"
                  name="name"
                  value={name}
                  placeholder="Your Name"
                  onChange={(e) => {
                    handleChange(e);
                    setError((old) => {
                      return {
                        ...old,
                        nameError: false,
                      };
                    });
                  }}
                />
              </div>
              <VisibleError show={nameError} name="Full Name" />
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="form-group">
                <HiOutlineMail />
                <input
                  type="text"
                  name="email"
                  value={email}
                  placeholder="Your Email"
                  onChange={(e) => {
                    handleChange(e);
                    setError((old) => {
                      return {
                        ...old,
                        emailError: false,
                      };
                    });
                  }}
                />
              </div>
              <VisibleError show={emailError} name="Email" />
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="form-group">
                <FiPhoneCall />
                <input
                  type="text"
                  name="phoneNumber"
                  value={phoneNumber}
                  placeholder="Phone Number"
                  onChange={(e) => {
                    handleChange(e);
                    setError((old) => {
                      return {
                        ...old,
                        phoneNumberError: false,
                      };
                    });
                  }}
                />
              </div>
              <VisibleError show={phoneNumberError} name="Phone Number" />
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="subscribe-btn">
                <button disabled={loader} onClick={handleSubmit}>
                  {loader ? (
                    <div className="d-flex justify-content-center">
                      <TailSpin height="25" width="25" color="#000" />
                    </div>
                  ) : (
                    <>
                      <HiArrowNarrowRight />
                      get in touch
                    </>
                  )}
                </button>
              </div>
            </div>
          </Row>
        </Container>
      </section>
      <div className="main-footer">
        <Container>
          <Row>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="support-box">
                <img src={Logo} alt="" />
              </div>
              <div className="text">
                <p>
                  Our goal to help our companies maintains achieve best position
                  their respective industries best team work that work have hand
                  to be repudiated.
                </p>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="links-widget">
                <div className="widget-title">
                  <h5>Company</h5>
                </div>
                <div className="widget-content">
                  <ul className="links-list">
                    <li>
                      <a href="/">Expertise</a>
                    </li>
                    <li>
                      <a href="/">Projects</a>
                    </li>
                    <li>
                      <a href="/">Solutions</a>
                    </li>
                    <li>
                      <a href="/">Responsibility</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="links-widget">
                <div className="widget-title">
                  <h5>Media Center</h5>
                </div>
                <div className="widget-content">
                  <ul className="links-list">
                    <li>
                      <a href="/">Careers</a>
                    </li>
                    <li>
                      <a href="/">Contact</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-6 col-sm-12">
              <div className="links-widget post-widget">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d29480.061025796218!2d88.386805!3d22.541387!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a02768ae3fc9053%3A0xfbc1540ebc29ce5d!2sZeeshan%20Construction!5e0!3m2!1sen!2sin!4v1684564221033!5m2!1sen!2sin"
                  width="100%"
                  allowFullScreen=""
                  title="map"
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </Row>
        </Container>
      </div>
      <div className="footer-bottom">
        <Container>
          <Row>
            <Col sm="12">
              <div className="copyright-main">
                <div className="copyright">
                  <p>
                    Copyright &copy; 2023 <a href="/">The Zeeshan Group</a> . All
                    Rights Reserved.
                  </p>
                </div>
                <div>
                  <ul className="footer-nav">
                    <li>
                      <a href="/">Terms & Conditions</a>
                    </li>
                    <li>
                      <a href="/">Privacy Policy</a>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};




export default Footer;
